module.exports = __webpack_public_path__ + "media/WebsiteBackgroundcompressed.81beb664.mp4";